module.exports = __webpack_public_path__ + "3b5276259885cc5f272fef2fbd19488f.gif";